import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20flowing%20golden%20and%20amber%20light%20particles%20resembling%20starlight%20through%20film%20strip%2C%20elegant%20and%20artistic%20movie%20theater%20aesthetic%2C%20warm%20golden%20and%20crimson%20tones%20on%20deep%20charcoal%20background%2C%20luxurious%20cinematic%20atmosphere%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="星空影院 - 高清影视在线播放"
        className="absolute inset-0 w-full h-full object-cover"
        title="星空影院 高清视频 超清画质 4K影视"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 text-center px-4 w-full">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
            <i className="ri-movie-line text-3xl md:text-4xl text-primary-500"></i>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 tracking-wide">
            星空影院
          </h1>
        </div>

        <p className="text-base md:text-xl text-foreground-200 max-w-2xl mx-auto mb-4 leading-relaxed">
          高清视频 · 超清画质 · 4K影视不缓冲
        </p>
        <p className="text-sm md:text-lg text-foreground-400 max-w-2xl mx-auto mb-8 leading-relaxed">
          蓝光画质无广告观影，热门电影电视剧在线免费看，追剧体验全面升级
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-950 dark:text-foreground-950 font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-foreground-100 border border-foreground-200/20 rounded-full text-sm hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10">
          {[
            { icon: 'ri-4k-line', label: '4K超清' },
            { icon: 'ri-shield-check-line', label: '无广告' },
            { icon: 'ri-speed-up-line', label: '不缓冲' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-1">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm">
                <i className={`${item.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <span className="text-xs text-foreground-300 whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}